import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from './../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

function Assign({ action, variables, setOpenVariable, setField, disabled, outputVisible }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.ASSIGN.';

  return (
    <div>
      <div className="form-element">
        {t(label + 'ASSIGN-VALUE')}
        <TextInput
          action={action}
          inputName="assignValue"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
          fieldType="number"
          displayName={t(label + 'ASSIGN-VALUE')}
          setField={setField}
        />
      </div>
      {
        !outputVisible &&
        <div className="form-element">
          {t(label + 'ASSIGN-SOURCE')}
          <VariablePicker
            action={action}
            inputName="assignSource"
            variables={variables}
            setOpenVariable={setOpenVariable}
            filter="number"
            isRequired
            disabled={disabled}
          />
          <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'number' })}</em></small>
        </div>
      }

    </div>
  );
}

export default Assign;